import { WARRCHIRP_EXPERIENCE_API_URL } from 'config';
import type {
  GetUserProfileResponseDTO,
  UpdateUserRequestBodyDTO,
  UploadUserColumnPreferences,
} from 'declarations/dto/user';

import { get, post, put } from './api';

export const getUserProfile = async (): Promise<GetUserProfileResponseDTO> => {
  const response = await get<GetUserProfileResponseDTO>(
    '/users/profile',
    {},
    {
      baseURL: `${WARRCHIRP_EXPERIENCE_API_URL}`,
    }
  );

  return response.data;
};

export const putUserProfile = async (userProfileData: UpdateUserRequestBodyDTO): Promise<void> => {
  const response = await put<void>(
    `/users/${userProfileData.get('UserId')}`,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- FormData is serializable by Axios
    userProfileData as any,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
  );

  return response.data;
};

export const getUserColumnPreferences = async (): Promise<string> => {
  const response = await get<string>('/users/column-preferences');

  return response.data;
};

export const uploadUserColumnPreferences = async (
  data: UploadUserColumnPreferences
): Promise<void> => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- DTO body is serializable by Axios
  const response = await post<void>('/users/column-preferences', data as any);

  return response.data;
};
